import React from 'react';
import { Button } from 'react-bootstrap';
import secondStepConstanst from '../assets/items.json'


class SecondStep extends React.Component {
  constructor(props) {
    super(props);

    // Setup save/read top component state.
    this.saveTopState = props.saveTopState;
    this.readTopState = props.readTopState;

    let savedFirstState = this.readTopState('firstStepState');

    // Reading state parameters from top state.
    let savedStateFromTop = this.readTopState('secondStepState');

    this.state = {
      firstStepState: savedFirstState.movingFromAddress ? savedFirstState : {
        "movingFromAddress": { "value": { "lat": 28.8240644, "lng": -81.3185346 }, "label": "Manhattan, New York, NY, USA", "isValid": true, "cityAndState": { "city": "New York", "state": "NY" } }, "movingToAddress": { "value": { "lat": 31.05679419999999, "lng": -89.18937199999999 }, "label": "Brooklyn, MS 39425, USA", "isValid": true, "cityAndState": { "city": "Brooklyn", "state": "MS" } }, "movingTypeFrom": { "value": "1", "label": "Studio" }, "movingFromFlights": { "value": "2", "label": "2nd floor walk up" }, "movingToFlights": { "value": "0", "label": "Ground floor" }, "moveSize": { "value": "1", "label": "Studio or Partial Apartment" }, "movingDate": "2018-11-24", "errorclass": "before-error-validation", "distance": 9, "isValid": false
      },
      items: savedStateFromTop['items'] || {},
      additionalText: savedStateFromTop['additionalText'] || "",
      totalVolume: savedStateFromTop['totalVolume'] || 0,
      customItems: savedStateFromTop['customItems'] || {},
      customItemIndex: savedStateFromTop['customItemIndex'] || 0,
      packingOption: savedStateFromTop['packingOption'] || {},
      storageAcOption: savedStateFromTop['storageAcOption'] || {},
      storageDuration: savedStateFromTop['storageDuration'] || {},
      referrence: savedStateFromTop['referrence'] || {},
      volumeErrorMsg: 'hide-error-msg',
      customItemsErrorMsg: 'hide-error-msg'
    };

    // Binding all methods
    this.onQuantityChange = this.onQuantityChange.bind(this);
    this.onItemPlus = this.onItemPlus.bind(this);
    this.onItemMinus = this.onItemMinus.bind(this);
    this.calculateTotalVolume = this.calculateTotalVolume.bind(this);
    this.addCustomItem = this.addCustomItem.bind(this);
    this.removeCustomItem = this.removeCustomItem.bind(this);
    this.onInputFieldChange = this.onInputFieldChange.bind(this);
    this.onCustomItemFieldChange = this.onCustomItemFieldChange.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }
  componentDidMount() {

    /**FRONT END BETWEEN STEPS STYLE**/
    if (document.getElementById("second-step-change")) {
      document.querySelector(".second-step-expand").classList.add("second-step-expandthis");
      if (document.querySelector(".second-step-hide")) {
        document.querySelector(".second-step-hide").classList.add("second-step-hidethis");
      }
    }
    if (document.querySelector(".hero-section")) {
      if (document.querySelector(".hero-section")) {
        document.querySelector(".hero-section").classList.add("second-hero-section");
      }
    }
  }

  /**FRONT END BETWEEN STEPS STYLE**/
  /*
   * Changing quantity of inventory element when input field is selected and typed.
   * @param  {[type]} event       general event
   * @param  {[type]} currentItem item that needs to be saved
   * @param  {[type]} room        location of the item
   * @return {[type]}             nothing
   */
  onQuantityChange(event, currentItem, room) {

    // Get all saved items from the state.
    let items = this.state.items;

    // Get or set the quantity to 0.
    let quantity = (parseInt(event.target.value, 10)) ? parseInt(event.target.value, 10) : 0;

    // If room is not set, set it up.
    if (!items[room]) {
      items[room] = {
        name: room,
        elements: {}
      }
    }

    // Save item and call method for calculating total volume.
    items[room]['elements'][currentItem.name] = {
      name: currentItem.name,
      quantity: quantity,
      volume: currentItem.cf,
      theprice: parseInt(currentItem.price, 10),
      thetime: parseInt(currentItem.time, 10)
    }

    this.setState({
      items: items
    }, this.calculateTotalVolume())
  }


  /**
   * Change quantity of a element on plus button click
   * @param  {[type]} currentItem [description]
   * @param  {[type]} room        [description]
   * @return {[type]}             [description]
   */
  onItemPlus(currentItem, room) {

    // Get all saved items from the state.
    let items = this.state.items;

    //Set quantity
    let quantity = 0;
    if (items[room]) {
      if (items[room]['elements'][currentItem.name]) {
        quantity = items[room]['elements'][currentItem.name]['quantity'];
      }
    }

    //Set room if not defiend
    if (!items[room]) {
      items[room] = {
        name: room,
        elements: {}
      }
    }

    // Save item and call method for calculating total volume.
    quantity = quantity + 1;

    items[room]['elements'][currentItem.name] = {
      name: currentItem.name,
      quantity: quantity,
      volume: currentItem.cf,
      theprice: parseInt(currentItem.price, 10),
      thetime: parseInt(currentItem.time, 10)
    }

    this.setState({
      items: items
    }, this.calculateTotalVolume())
  }


  /**
   * Change quantity of a element on minus button click
   * @param  {[type]} currentItem [description]
   * @param  {[type]} room        [description]
   * @return {[type]}             [description]
   */
  onItemMinus(currentItem, room) {
    // Get all saved items from the state.
    let items = this.state.items;

    // Set start quantity
    let quantity = 0;

    // Do the quantity change if room exists (it must exist if item quanity is higher than 0)
    if (items[room]) {
      if (items[room]['elements'][currentItem.name] && items[room]['elements'][currentItem.name]['quantity'] > 0) {
        quantity = items[room]['elements'][currentItem.name]['quantity'];
        quantity = quantity - 1;
        items[room]['elements'][currentItem.name] = {
          name: currentItem.name,
          quantity: quantity,
          volume: currentItem.cf,
          theprice: parseInt(currentItem.price, 10),
          thetime: parseInt(currentItem.time, 10)
        }

        if (quantity === 0) {
          delete items[room]['elements'][currentItem.name];

          if (Object.keys(items[room]['elements']).length === 0 && items[room]['elements'].constructor === Object) {
            delete items[room];
          }
        }

        // Save and call calculate method
        this.setState({
          items: items
        }, this.calculateTotalVolume());
      }
    }
  }


  /**
   * Method for adding custom items
   * @return {[type]} [description]
   */
  addCustomItem() {

    // Get all values with refs attribute
    const name = this.refs.customItemName.value;
    const lenght = parseInt(this.refs.customItemLenght.value, 10);
    const width = parseInt(this.refs.customItemWidth.value, 10);
    const height = parseInt(this.refs.customItemHeight.value, 10);
    let quantity = parseInt(this.refs.customItemQuantity.value, 10);


    // If all values are defined
    if (name && lenght && width && height && quantity) {

      // Get all items
      let items = this.state.items;
      // If there is no room 'custom items' create one
      let customItems = this.state.items['Custom Items'] || { name: 'Custom Items', elements: {} };

      // Set custom item index so we can use it when deliting custom items
      let customItemIndex = this.state.customItemIndex;
      customItemIndex = customItemIndex + 1;

      // Calculate custom items volume based on input fields
      let customItemCf = (lenght * width * height / 1000000).toFixed(2);

      // Save custom item into a variable
      customItems['elements'][customItemIndex] = {
        'name': name,
        'lenght': lenght,
        'width': width,
        'height': height,
        'quantity': quantity,
        'volume': customItemCf,
        'theprice': 0,
        'thetime': 0
      }

      // Set all items room 'Custom Items' from the variable
      items['Custom Items'] = customItems;

      // Save custom items and custom items index to state and calculate volume
      this.setState({
        items: items,
        customItemIndex: customItemIndex,
      }, this.calculateTotalVolume());

      // Empty all input fields so visitor create a new custom item
      this.refs.customItemName.value = '';
      this.refs.customItemLenght.value = '';
      this.refs.customItemWidth.value = '';
      this.refs.customItemHeight.value = '';
      this.refs.customItemQuantity.value = '';

    }
    else {

      // If all input fields are not defined show error
      this.refs.customItemName.className = !name ? 'input-error' : '';
      this.refs.customItemLenght.className = !lenght ? 'input-error' : '';
      this.refs.customItemWidth.className = !width ? 'input-error' : '';
      this.refs.customItemHeight.className = !height ? 'input-error' : '';
      this.refs.customItemQuantity.className = !quantity ? 'input-error' : '';
    }
  }


  /**
   * Showing errors if custom item fields are deleted
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  onCustomItemFieldChange(event) {
    event.target.className = !event.target.value ? 'input-error' : '';
  }


  /**
   * Removing custom when clicked on the remove button
   * @param  {[type]} itemToBeRemoved [description]
   * @return {[type]}                 [description]
   */
  removeCustomItem(itemToBeRemoved) {
    // Get all items from state
    let items = this.state.items;

    // Delete item that matches the index of clicked itemm, save to state and calculate volume
    delete items['Custom Items']['elements'][itemToBeRemoved];
    this.setState({
      items: items,
    }, this.calculateTotalVolume());
  }


  /**
  * Calculate total volume based on all saved items
  * @return {[type]} [description]
  */
  calculateTotalVolume() {
    let totalVolume = 0;

    // Loop through all rooms and get volume and quantity of all items and calculate the sum
    Object.keys(this.state.items).forEach(room =>
      Object.keys(this.state.items[room]['elements']).forEach(item => {
        totalVolume = totalVolume + this.state.items[room]['elements'][item].volume * this.state.items[room]['elements'][item].quantity;
      })
    );

    // Save total volume to State and hide volume eror message if there is any
    this.setState({
      totalVolume: totalVolume,
      volumeErrorMsg: 'hide-error-msg'
    }, () => console.log(this.state));

  }


  /**
  * Method for validating and saving dropdown input field value
  * @param  {[type]} event input field that is changing
  * @return {[type]}       adding or removing error class
  */
  onInputFieldChange(event) {
    event.preventDefault();
    let { name, value, type } = event.target;

    // Set default validity indicator to false
    let isFieldValid = false;

    if (type === "textarea") {
      this.setState({
        [name]: value
      });
    } else {
      // Save input field to state
      this.setState({
        [name]: {
          'value': event.target.options[event.target.selectedIndex].value,
          'label': event.target.options[event.target.selectedIndex].text,
        }
      });
    }


    // If there is value that means that option is selected and show/hide error based on that
    isFieldValid = value ? true : false;
    event.target.className = (isFieldValid ? 'input-valid' : 'input-error');
  }


  /**
  * Method for validating and saving dropdown input field value
  * @param  {[type]} event input field that is changing
  * @return {[type]}       adding or removing error class
  */
  handleOptionChange(event) {
    let { name, type } = event.target;

    if (event.target.value === 1) {
      console.log('AC Storage')
    } else {
      console.log('Non AC Storage')
    }

    this.setState({
      [name]: {
        "label": event.target.label,
        "value": event.target.value
      },
    }, () => console.log(this.state));
  }


  /**
   * Checking all inputs and calling third step if ok
   * @param  {[type]} event button to be clicked
   * @return {[type]}       third step or error msg
   */
  handleNext(event) {
    event.preventDefault();

    // Checking that all user inputs are inserted
    if (this.state.totalVolume > 0 && (this.state.packingOption.value < 5 || (this.state.packingOption.value > 4 && this.state.storageAcOption.value > 0 && this.state.storageDuration.value > 0)) && this.state.referrence.value) {
      const calcFormAnchor = (window.scrollY + document.getElementById('calcForm').getBoundingClientRect().top - 200);
      const activeStep = this.readTopState('activeStep');
      this.saveTopState({

        // Going to next step and saving all variables to state
        secondStepState: this.state,
        activeStep: activeStep + 1,
      }, () => window.scrollTo(0, calcFormAnchor));

    }
    // Activating error class if some inputs are not defined
    else {

      // If there are not items, show error msg, if there are, just show dropdown errors
      if (this.state.totalVolume === 0) {
        this.setState({
          errorclass: 'input-error',
          volumeErrorMsg: 'show-error-msg',
          bedSizeErrorMsg: 'hidden'
        });
      }

      else {
        this.setState({
          errorclass: 'input-error',
          bedSizeErrorMsg: 'hidden'
        });
      }
    }

    // Adding className for red color if Storage Option is not selected
    if (this.state.packingOption.value === '5') {
      let storageLabel = document.querySelector('.cc-storage');
      if (this.state.storageAcOption.value === undefined) {
        storageLabel.classList.add('error');
      }
      else {
        storageLabel.classList.remove('error');
      }
    }
  }

  handleCheckboxChange(event) {

    let { name } = event.target;

    let elementchecked = "No";


    if (event.target.checked === true) {
      elementchecked = "Yes";
    }

    // Saving to state
    this.setState({
      [name]: {
        'value': elementchecked,
        'checked': event.target.checked
      },
    }, () => console.log(this.state));

  }

  /**
   * Going on the previous step
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  handleBack(event) {

    const calcFormAnchor = (window.scrollY + document.getElementById('calcForm').getBoundingClientRect().top - 200);

    event.preventDefault();

    const activeStep = this.readTopState('activeStep');
    this.saveTopState({
      activeStep: activeStep - 1,
      secondStepState: this.state,
    }, () => window.scrollTo(0, calcFormAnchor));


  };

  handleToggle(event) {
    event.preventDefault();

    /**hide all elements if any are open**/
    let hideAll = document.querySelectorAll(".hideRooms");
    let rotateAllBack = document.querySelectorAll("h3[data-togglerooms]");
    let hideThisRoom = event.currentTarget.dataset.togglerooms;
    let hideThisElement = document.getElementById(hideThisRoom);


    hideAll.forEach(el => {
      if (hideThisElement !== el) {
        el.classList.add('hideElement');
      }
    });


    rotateAllBack.forEach(el => {
      if (event.target !== el) {
        el.classList.remove('rotateBeforeEl');
      }
    });
    /**toggle class**/

    hideThisElement.classList.toggle('hideElement');
    event.target.classList.toggle('rotateBeforeEl');

    /**change direction of arrows**/

    event.target.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
    // window.scrollBy(0, -200);

  }
  //style={{display: this.state.isToggle ? 'block': 'none'}}

  render() {

    return (

      <div className="qc-second-step">
        {Object.keys(secondStepConstanst['rooms']).map(room =>
          <div key={secondStepConstanst['rooms'][room]['name']} className="qc-room">
            <h3 onClick={this.handleToggle} data-togglerooms={secondStepConstanst['rooms'][room]['name']}>{secondStepConstanst['rooms'][room]['name']}</h3>
            <div id={secondStepConstanst['rooms'][room]['name']} className="hideRooms hideElement">
              {Object.keys(secondStepConstanst['rooms'][room]['category']).map(category =>
                <div key={secondStepConstanst['rooms'][room]['category'][category]['name']} className="no-margin qc-room-category">
                  <div className="inner-room">
                    {Object.keys(secondStepConstanst['rooms'][room]['category'][category]['items']).map(item => {

                      // Looping through rooms, categories and items get values for every element and store
                      let currentRoom = secondStepConstanst['rooms'][room]['name'];
                      let currentItem = secondStepConstanst['rooms'][room]['category'][category]['items'][item];
                      let imgUrl = '/wp-content/plugins/quote-calculator-r/assets/img/' + currentItem['img'];

                      // Set quantity to defaul 0, and then pick value from state it there is any
                      let currentItemQuantity = 0;
                      if (this.state.items[currentRoom]) {
                        if (this.state.items[currentRoom]['elements'][currentItem.name]) {
                          currentItemQuantity = this.state.items[currentRoom]['elements'][currentItem.name]['quantity']
                        }
                      }

                      return (

                        <div key={secondStepConstanst['rooms'][room]['category'][category]['items'][item]['name']} className={'qc-item ' + currentRoom + ' ' + currentItem['class']}>
                          <div className='new-inner'>
                            <div className="qc-item-inner">
                              <div className="qc-item-title noppading">
                                <p>{currentItem['name']}</p>
                              </div>
                              <div className="qc-inner-item-container">
                                <div className="qc-item-picture noppading">
                                  <img src={imgUrl} alt="item-icon" />
                                </div>

                                <div className="qc-item-controls noppading nomargin">
                                  <button onClick={() => this.onItemPlus(currentItem, currentRoom)} type="button">+</button>
                                  <button onClick={() => this.onItemMinus(currentItem, currentRoom)} type="button">-</button>
                                </div>
                                <div className="qc-item-quantity noppading nomargin">
                                  <input onChange={(event) => this.onQuantityChange(event, currentItem, currentRoom)} value={currentItemQuantity} type="number" />
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }

                    )}
                  </div>
                </div>

              )}
            </div>
          </div>
        )}

        <div className="custom-items">
          <h3 onClick={this.handleToggle} data-togglerooms="custom-items-toggle" className="qc-room__title ng-binding custom-item-title">Custom Items</h3>
          <div className="hideElement" id="custom-items-toggle">
            <h4>Add your custom items</h4>
            <div className="custom-item-holder">
              <div>
                <input type="text" ref="customItemName" placeholder="Item Name" onChange={this.onCustomItemFieldChange} />
              </div>
              <div>
                <input type="number" min="0" ref="customItemLenght" placeholder="Length (cm)" onChange={this.onCustomItemFieldChange} />
              </div>
              <div>
                <input type="number" min="0" ref="customItemWidth" placeholder="Width (cm)" onChange={this.onCustomItemFieldChange} />
              </div>
              <div>
                <input type="number" min="0" ref="customItemHeight" placeholder="Height (cm)" onChange={this.onCustomItemFieldChange} />
              </div>
              <div>
                <input type="number" min="0" ref="customItemQuantity" placeholder="Quantity" onChange={this.onCustomItemFieldChange} />
              </div>
              <div>
                <input type="button" value="Add" id="custom-button" onClick={() => this.addCustomItem()} />
              </div>
            </div>
          </div>
        </div>
        {this.state.items['Custom Items'] ? Object.keys(this.state.items['Custom Items']['elements']).map(customItem =>
          <div key={this.state.items['Custom Items']['elements'][customItem].name} className="custom-item-generated">
            <div>
              <input type="text" value={this.state.items['Custom Items']['elements'][customItem].name} disabled />
            </div>
            <div>
              <input type="text" value={'Quantity: ' + this.state.items['Custom Items']['elements'][customItem].quantity} disabled />
            </div>
            <div>
              <input type="text" value={'Volume: ' + this.state.items['Custom Items']['elements'][customItem].volume + 'cbm'} disabled />
            </div>
            <div className="steps-navigation">
              <input type="button" className="btn" name="custom-button-remove" value="Remove" onClick={() => this.removeCustomItem(customItem)} />
            </div>
          </div>
        ) : ''}
        <h3 className="md-sub-head">Additional Information:</h3>
        <div className="additional-txt packing-text">
          <textarea defaultValue={this.state.additionalText} placeholder="Specify here any additional stops, deadlines, freight entrances, building restrictions, long walks, additional steps or relevant information pertaining to this move." type="textarea" rows="4" cols="50" name="additionalText" onChange={this.onInputFieldChange}></textarea>
        </div>
        <h3 className="md-sub-head">Move Types:</h3>
        <p className='md-packing-title-p'>&amp; What They Include</p>
        <div className="packing-table">
          <div className="packing-table-inner">

            <div className='move-type-wrap'>
              <div className='inner-move-wrap'>
                <div className='type-heading-wrap'>
                  <h4 className='move-type-heading'>Basic Move</h4>
                  <p className='type-after-head'>No packing</p>
                </div>
                <div className='type-description-wrap'>
                  <p className='type-description'>Not Included Packing Materials</p>
                </div>
                <div className='type-list-wrap'>
                  <ul>
                    <li className='include'>Dismantling of Furniture &amp; White Goods</li>
                    <li className='include'>Transportation</li>
                    <li className='include'>Reassebling of Furniture &amp; White Goods</li>
                    <li className='not-include'>Packing of Furniture</li>
                    <li className='not-include'>Packing of Small Items</li>
                    <li className='not-include'>Unpacking of Furniture</li>
                    <li className='not-include'>Unpacking of Small Items</li>
                    <li className='not-include'>Handyman Services (Curtain/wall hangings)</li>
                    <li className='not-include'>Debris Clearance</li>
                    <li className='not-include'>All Risk Insurance</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className='move-type-wrap'>
              <div className='inner-move-wrap'>
                <div className='type-heading-wrap'>
                  <h4 className='move-type-heading'>Economy Move</h4>
                  <p className='type-after-head'>Self packing</p>
                </div>
                <div className='type-description-wrap'>
                  <p className='type-description'>Dedicated Plastic Moving Boxes will be provided for Packing Small Items</p>
                </div>
                <div className='type-list-wrap'>
                  <ul>
                    <li className='include'>Dismantling of Furniture &amp; White Goods</li>
                    <li className='include'>Packing of Furniture</li>
                    <li className='include'>Transportation</li>
                    <li className='include'>Unpacking of Furniture</li>
                    <li className='include'>Reassebling of Furniture &amp; White Goods</li>
                    <li className='not-include'>Packing of Small Items</li>
                    <li className='not-include'>Unpacking of Small Items</li>
                    <li className='not-include'>Handyman Services (Curtain/wall hangings)</li>
                    <li className='not-include'>Debris Clearance</li>
                    <li className='not-include'>All Risk Insurance</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className='move-type-wrap'>
              <div className='inner-move-wrap standard-move-wrap'>
                <div className='type-heading-wrap'>
                  <h4 className='move-type-heading'>Standard Move</h4>
                  <p className='type-after-head'>Standard packing</p>
                </div>
                <div className='type-description-wrap'>
                  <p className='type-description'>Standard Packing will be done by our professionals</p>
                </div>
                <div className='type-list-wrap'>
                  <ul>
                    <li className='include'>Dismantling of Furniture &amp; White Goods</li>
                    <li className='include'>Packing of Furniture</li>
                    <li className='include'>Packing of Small Items</li>
                    <li className='include'>Transportation</li>
                    <li className='include'>Unpacking of Furniture</li>
                    <li className='include'>Unpacking of Small Items</li>
                    <li className='include'>Reassebling of Furniture &amp; White Goods</li>
                    <li className='include'>Handyman Services (Curtain/wall hangings) - <span>Limited</span></li>
                    <li className='include'>Debris Clearance</li>
                    <li className='include'>All Risk Insurance - <span>Chargeable</span></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className='move-type-wrap'>
              <div className='inner-move-wrap premium-move-wrap'>
                <div className='type-heading-wrap'>
                  <h4 className='move-type-heading'>Premium Move</h4>
                  <p className='type-after-head'>Premium packing</p>
                </div>
                <div className='type-description-wrap'>
                  <p className='type-description'>Premium Packing will be done by our professionals. (New Materials)</p>
                </div>
                <div className='type-list-wrap'>
                  <ul>
                    <li className='include'>Dismantling of Furniture &amp; White Goods</li>
                    <li className='include'>Packing of Furniture</li>
                    <li className='include'>Packing of Small Items</li>
                    <li className='include'>Transportation</li>
                    <li className='include'>Unpacking of Furniture</li>
                    <li className='include'>Unpacking of Small Items</li>
                    <li className='include'>Reassebling of Furniture &amp; White Goods</li>
                    <li className='include'>Handyman Services (Curtain/wall hangings) - <span>Limited</span></li>
                    <li className='include'>Debris Clearance</li>
                    <li className='include'>All Risk Insurance - <span>Up to 10k</span></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className='move-type-wrap'>
              <div className='inner-move-wrap'>
                <div className='type-heading-wrap'>
                  <h4 className='move-type-heading'>Storage Move</h4>
                  <p className='type-after-head'>Storage packing</p>
                </div>
                <div className='type-description-wrap'>
                  <p className='type-description'>Storage Packing will be done by our professionals</p>
                </div>
                <div className='type-list-wrap'>
                  <ul>
                    <li className='include'>Dismantling of Furniture &amp; White Goods</li>
                    <li className='include'>Packing of Furniture</li>
                    <li className='include'>Transportation</li>
                    <li className='include'>Packing of Small Items</li>
                    <li className='include'>Handyman Services (Curtain/wall hangings) - <span>Limited</span></li>
                    <li className='include'>Debris Clearance</li>
                    <li className='include'>All Risk Insurance - <span>Chargeable</span></li>
                    <li className='not-include'>Unpacking of Furniture</li>
                    <li className='not-include'>Reassebling of Furniture &amp; White Goods</li>
                    <li className='not-include'>Unpacking of Small Items</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="qc-packing">
          <div className="md-select-bg">
            <select name="packingOption" type="select" defaultValue={this.state.packingOption.value || 0} className={!this.state.packingOption.label ? this.state.errorclass : "untouched"} onChange={this.onInputFieldChange}>
              <option disabled value="0">Move Type Selection</option>
              {Object.keys(secondStepConstanst['packaging']).map(option =>
                <option name="packingOption" key={secondStepConstanst['packaging'][option]['type']} value={secondStepConstanst['packaging'][option]['type']}>{secondStepConstanst['packaging'][option]['name']}</option>
              )};
            </select>
          </div>
          <div style={this.state.packingOption.value === '5' ? { display: 'block' } : { display: 'none' }} className="md-select-bg storage-ac">
            <div className="md-storage-labels-wrap">
              <span className="cc-storage">Storage Type: </span>
              <div className="storage-labels">
                <label className="cc-label-storage">A/C Storage
                  <input name="storageAcOption" type="radio" value="1" className={!this.state.storageAcOption.label ? this.state.errorclass : "untouched"} checked={this.state.storageAcOption.value === '1'} onChange={this.handleOptionChange}></input>
                </label>
                <label className="cc-label-storage">Non A/C Storage
                  <input name="storageAcOption" type="radio" value="2" className={!this.state.storageAcOption.label ? this.state.errorclass : "untouched"} checked={this.state.storageAcOption.value === '2'} onChange={this.handleOptionChange}></input>
                </label>
              </div>
            </div>
          </div>

          <div style={this.state.packingOption.value === '5' ? { display: 'block' } : { display: 'none' }} className="md-select-bg storage-duration">
            <select name="storageDuration" type="select" defaultValue={this.state.storageDuration.value || 0} className={!this.state.storageDuration.label ? this.state.errorclass : "untouched"} onChange={this.onInputFieldChange}>
              <option disabled value="0">Storage Duration</option>
              {Object.keys(secondStepConstanst['storageDuration']).map(option =>
                <option name="storageDuration" key={secondStepConstanst['storageDuration'][option]['value']} value={secondStepConstanst['storageDuration'][option]['value']}>{secondStepConstanst['storageDuration'][option]['name']}</option>
              )};
            </select>
          </div>

          <div className="md-select-bg">
            <select name="referrence" type="select" defaultValue={this.state.referrence.value || 0} className={!this.state.referrence.label ? this.state.errorclass : "untouched"} onChange={this.onInputFieldChange}>
              <option disabled value="0">How Did You Hear About us</option>
              {Object.keys(secondStepConstanst['referrence']).map(option =>
                <option name="referrence" key={secondStepConstanst['referrence'][option]['type']} value={secondStepConstanst['referrence'][option]['type']}>{secondStepConstanst['referrence'][option]['name']}</option>
              )};
            </select>
          </div>
        </div>

        <span className={this.state.volumeErrorMsg}>Please select furniture</span>

        <div className="steps-navigation btn-x-2">
          <div className="vm-prev-btn">
            <Button type="submit" onClick={this.handleBack}>Previous</Button>
          </div>
          <div className="sec-next-btn">
            <Button type="submit" onClick={this.handleNext}>Next</Button>
          </div>
        </div>
      </div>
    );
  }
}

export default SecondStep;



// WEBPACK FOOTER //
// ./src/steps/SecondStep.js